import http from "../../../services/httpService";

/**
 * Camera-model access to the shared, dual-keyed `/missedthefts/` endpoint.
 *
 * The endpoint carries both `channel` (legacy PK) and `camera` (public_id) during
 * the migration; the camera-model UI works exclusively with the `camera` public_id
 * (`cam_*`) — the server cross-fills the legacy `channel` side. The camera tree does
 * NOT embed missed thefts, so the UI reads them here via `?camera=<public_id>`.
 */

const ENDPOINT = "/missedthefts/";

/** Normalise a list response (plain array or DRF `{ results }` pagination). */
function unwrap(response) {
  const data = response?.data;
  if (Array.isArray(data)) return data;
  return data?.results ?? [];
}

/**
 * Fetch a camera's missed thefts.
 *
 * @param {string} cameraPublicId - The camera public id (`cam_*`).
 * @returns {Promise<Array>} The camera's missed-theft rows (may be empty).
 */
export function fetchCameraMissedThefts(cameraPublicId) {
  return http.get(ENDPOINT, { params: { camera: cameraPublicId } }).then(unwrap);
}

/**
 * Bulk-create missed thefts (add-only). Each item is keyed by camera public_id;
 * the server resolves and stores the legacy `channel` counterpart when it can.
 *
 * @param {Array<{camera: string, date: string, operating_mode: number}>} missedThefts - Rows to create.
 * @returns {Promise<Array>} The created rows (with ids + operating_mode_name).
 */
export function saveCameraMissedThefts(missedThefts) {
  return http.post(ENDPOINT, missedThefts).then(unwrap);
}
